import { atom } from "jotai";

export const selectedProductToShowRateAtom = atom<string | number | null>(null);
